import React, { useState,useEffect,useRef } from "react";

const EmergencyContactModal = ({ userData, onUpdate }) => {
  const [editedData, setEditedData] = useState(userData);
  const [errors, setErrors] = useState({});
  const submitButtonRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  useEffect(() => {

    setEditedData({
      ...userData,
    });
  }, [userData]);


  const handleValidation = () => {
    const newErrors = {};
    if (!editedData.emergency_contact) newErrors.emergency_contact = "Emergency Contact is required";
    if (!editedData.emergency_contact_relation) newErrors.emergency_contact_relation = "Relationship is required";
    if (!editedData.emergency_contact_phone) newErrors.emergency_contact_phone = "Phone is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      onUpdate(editedData); // Call the onUpdate function with edited data
      if (submitButtonRef.current) {
        submitButtonRef.current.click(); // Trigger the click event
      }
    } else {
      console.log("Form validation failed");
    }
  };

  return (
    <div id="emergency_contact_modal" className="modal custom-modal fade" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "40%" }}>
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title">Emergency Contact Information</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-block mb-3 mb-3">
                    <label className="col-form-label">Emergency Contact</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emergency_contact"
                      value={editedData.emergency_contact || ""}
                      onChange={handleChange}
                    />
                    {errors.emergency_contact && (
                      <div className="text-danger">{errors.emergency_contact}</div>
                    )}
                  </div>
                  <div className="input-block mb-3 mb-3">
                    <label className="col-form-label">Relationship</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emergency_contact_relation"
                      value={editedData.emergency_contact_relation || ""}
                      onChange={handleChange}
                    />
                    {errors.emergency_contact_relation && (
                      <div className="text-danger">{errors.emergency_contact_relation}</div>
                    )}
                  </div>
                  <div className="input-block mb-3 mb-3">
                    <label className="col-form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emergency_contact_phone"
                      value={editedData.emergency_contact_phone || ""}
                      onChange={handleChange}
                    />
                    {errors.emergency_contact_phone && (
                      <div className="text-danger">{errors.emergency_contact_phone}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">Save</button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
            </form>
            <div style={{ display: 'none' }}>
                <button
                  ref={submitButtonRef}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="reset"
                >
                  Submit2
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactModal;
